/**
 * コメント種別
 * @description setup の外（module スコープ）に置き、コンポーネントのインスタンスごとに再生成されないようにする
 */
const COMMENT_TYPE = {
  COMMENT: 'comment',
  REPLY: 'reply',
} as const

/**
 * タイムラインのコメント表示まわりの派生ロジック
 * @description グローバルタイムライン（TimelineGlobal）とタイムラインページ（pages/timeline）で共通利用する
 */
export const useTimelineComment = () => {
  /**
   * コメントへのアンカー付き URL
   * @param item 対象のタイムラインアイテム
   * @returns 遷移先を持たないコンテンツの場合は undefined（アンカーを設定しない）
   */
  const commentURL = (item: TimelineItem): string | undefined => {
    return item.content.to ? `${item.content.to}#comment_${item.comment.id}` : undefined
  }

  /**
   * 返信コメントかどうか
   * @param commentType コメント種別
   */
  const isReply = (commentType: CommentType): boolean => {
    return commentType === COMMENT_TYPE.REPLY
  }

  return {
    // methods
    commentURL,
    isReply,
  }
}
